 import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import Select from 'react-select';
import { debounce } from 'lodash';

import {
  Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, Tab, Tabs, Dropdown,
  MenuItem, DropdownButton,
} from 'react-bootstrap';
import CashFormatter from '../Common/cashFormatter';
import { toFromDates, getDateRangeBetweenDates } from '../Common/cleanDates';
import { APP_COLORS, UI_HEIGHT } from '../Common/constants';
import customizableDateFilterRadios from '../Common/customizableDateFilterRadios';
import dateFilterRadios from '../Common/dateFilterRadios';
import { DateFormatter, formatDate } from '../Common/dateFormat';
import genericRadioFilter from '../Common/genericRadioFilter';
import { DisabledInputField } from '../Common/inputField';
import checkPermission from '../Common/permissions';
import { isDst } from '../Common/NumberUtil';
import { Selection, SelectionWithProps } from '../Common/selection';
import Spinner from '../../components/Widgets/spinner';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import TypeRadios from '../../containers/Common/TypeRadios';
import { 
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isABBLE, isGGI, isGFD, isLAP, isOLG,
  isOCM, isDAICHEONG, isCPG, isSH, isHO, isJRC, isSKH, isVIP, isCCW
} from '../../actions/root_url';
const styles = {
  titleLabel: {
    width: '50px',
    paddingTop: '4px',
    fontWeight: 'bold',
  },
  titleField: {
    width: '100px',
    marginRight: '10px',
  },
  titleLabel2: {
    width: '70px',
    paddingTop: '4px',
    fontWeight: 'bold',
  },
}
const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';
const isDev = ROOT_API_URL === 'https://dev-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isFung = ROOT_API_URL === 'https://fung-scm.truckxi.com/api/' || ROOT_URL === 'https://fung-scm.truckxi.com/api/';
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';

class SalesPerformance extends Component {
  constructor() {
    super();
    this.state = {

      spPdfFrameLoaded: true,

      limit: 'MSO',
      limitDisplay: 'MSO',

      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,
      byProduct: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      users: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        ToDate: null,
        FromDate: null,
        selectedRows: [],
        id: null,
        months: [],
        list: [],
      },
      saleQTY: 0,
      avgSalePrice: 0,
      avgMarkupPct: 0,
      sum: 0,
      currentDep: (isGFD && true) ? 1 : null,
      currentGroup: null,
      currentCategory: null,
      depExpanded: false,
      groupExpanded: false,
      hide: false,
      suggestValue: '',
      productSearchType: isSH ? 'Name' : 'ProductNum',
      tabsKey: 'ProductPerformance',

      // used for genericRadioFilter and DatePicker
      SalesType: 'all',
      Days: '1',
      FromDate: undefined,
      ToDate: undefined,
      userFromDate: null,
      userToDate: null,
      userDays: null,
      userTimeSelection: null,
      columns: [],
      Seller: undefined,
      Customer: undefined,
      // isSH
      pkgTp: {value: 'BX', label: 'BX'},
      checkedKeys: [],
      checkedChildKeys: [],
      checkedData: {},
      checkable: false
    };
    this.handleResize = this.handleResize.bind(this);
    this.fetchSalesPerformance = this.fetchSalesPerformance.bind(this);
  }

  componentWillMount() {
    document.title = companyCodeTitle;
    this.props.setDefaultOfForm('Days', '1', 'salesPerformance');
    this.props.setDefaultOfForm('userDays', '30', 'salesPerformance');
    this.props.setDefaultOfForm('SalesType', 'all', 'salesPerformance');
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.props.fetchBaseUsers();
    if ((isGFD && true)) {
      this.props.fetchDeps();
    } else {
      this.props.fetchGroups();
    }
    
    if(isSH) {
      this.props.fetchPackageTypes()
    }
    this.props.fetchActiveCustomers();
    this.props.setDefaultOfForm('Days', '1', 'salesPerformance');
    this.props.setDefaultOfForm('userDays', '30', 'salesPerformance');
    this.props.setDefaultOfForm('SalesType', 'all', 'salesPerformance');
    this.props.setDefaultOfForm('Seller', null, 'salesPerformance');
    this.props.setDefaultOfForm('Customer', null, 'salesPerformance');
    this.props.fetchMobileUsers(0, 200, '', '', '', '');
    this.props.fetchStores();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedCompany !== nextProps.selectedCompany) {
      if(isGGI) {
        this.props.fetchActiveCustomers();
      }
      this.props.fetchBaseUsers();
      this.refreshList();
    }
    if ((isOCM || isGGI || isABBLE) && this.props.selectedWarehouse !== nextProps.selectedWarehouse) {
      this.props.fetchBaseUsers();
      this.refreshList();
    }
    if (!nextProps.SalesType) {
      this.props.setDefaultOfForm('SalesType', 'all', 'salesPerformance');
    }
    if (!nextProps.Days) {
      this.props.setDefaultOfForm('Days', '1', 'salesPerformance');
    }
    if (!nextProps.userDays) {
      this.props.setDefaultOfForm('userDays', '30', 'salesPerformance');
    }
    if (nextProps.salesPerformance && nextProps.salesPerformance != this.props.salesPerformance) {
      const byProduct = { ...this.state.byProduct, rows: nextProps.salesPerformance.performance_lines };
      const saleQTY = nextProps.salesPerformance.SaleQTY;
      const avgSalePrice = nextProps.salesPerformance.AVGSalePrice;
      const avgMarkupPct = nextProps.salesPerformance.AvgMarkupPct || nextProps.salesPerformance.SalesMarginAvg;
      const sum = nextProps.salesPerformance.sum;
      this.setState({
        byProduct, saleQTY, avgSalePrice, avgMarkupPct, sum,
      });
    }
    if (nextProps.SalesType && nextProps.SalesType !== this.props.SalesType) {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      if (this.state.FromDate) {
        fromDate = this.formatDate(this.state.FromDate);
      }
      if (this.state.ToDate) {
        toDate = this.formatDate(this.state.ToDate);
      }
      const productNum = this.state.filterProductID;
      let dep = this.state.currentDep;
      let group = this.state.currentGroup;
      let category = this.state.currentCategory;
      if(dep === -1) {
        dep = null;
      }
      if(group === -1) {
        group = null;
      }
      if(category === -1) {
        category = null;
      }
      if(category) {
        group = null;
        dep = null;
      }
      // if (group) {
      //   dep = null;
      // }
      let seller = this.props.Seller;
      if (this.props.Seller) { seller = this.props.Seller.value; }
      let customer = this.props.Customer;
      if (this.props.Customer) { customer = this.props.Customer.value; }
      this.props.fetchSalesPerformanceByFilter(this.state.limit, nextProps.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, dep);
    }
    if (!(isGFD && true) && nextProps.groups && nextProps.groups !== this.props.groups) {
      const productGroup_id = nextProps.groups[0].ProductGroup_id;
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      if (this.state.FromDate) {
        fromDate = this.formatDate(this.state.FromDate);
      }
      if (this.state.ToDate) {
        toDate = this.formatDate(this.state.ToDate);
      }
      this.setState({ currentGroup: (isABBLE || isGGI || isLAP || isSH ) ? -1 : productGroup_id }, () => {
        let seller = this.props.Seller;
        if (this.props.Seller) { seller = this.props.Seller.value; }
        let customer = this.props.Customer;
        if (this.props.Customer) { customer = this.props.Customer.value; }
        let currentGroup = this.state.currentGroup;
        if(currentGroup === -1) {
          currentGroup = null;
        }
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', null, currentGroup, null, this.state.hide, seller, customer, store);
      });
    }
    if ((isGFD && true) && nextProps.deps && nextProps.deps !== this.props.deps) {
      let productDepartment_id = nextProps.deps[0].ProductDepartment_id;
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      if (this.state.FromDate) {
        fromDate = this.formatDate(this.state.FromDate);
      }
      if (this.state.ToDate) {
        toDate = this.formatDate(this.state.ToDate);
      }
      this.setState({ currentDep: (isABBLE || isGGI) ? -1 : productDepartment_id }, () => {
        let seller = this.props.Seller;
        if (this.props.Seller) { seller = this.props.Seller.value; }
        let customer = this.props.Customer;
        if (this.props.Customer) { customer = this.props.Customer.value; }
        let currentDep = this.state.currentDep;
        if(currentDep === -1) {
          currentDep = null;
        }
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', null, null, null, this.state.hide, seller, customer, store, currentDep);
      });
    }
    if (nextProps.FromDate && nextProps.FromDate !== this.state.FromDate || nextProps.ToDate && nextProps.ToDate !== this.state.ToDate) {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      if (nextProps.FromDate) {
        fromDate = this.formatDate(nextProps.FromDate);
      }
      if (nextProps.ToDate) {
        toDate = this.formatDate(nextProps.ToDate);
      }
      const productNum = this.state.filterProductID;
      let seller = this.props.Seller;
      if (this.props.Seller) { seller = this.props.Seller.value; }
      let customer = this.props.Customer;
      if (this.props.Customer) { customer = this.props.Customer.value; }
      let group = this.state.currentGroup;
      let category = this.state.currentCategory;
      let department = this.state.currentDep;
      if(group === -1) {
        group = null;
      }
      if(category === -1) {
        category = null;
      }
      if(category) {
        group = null;
        department = null;
      }
      this.props.fetchSalesPerformanceByFilter(this.state.limit, nextProps.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
    }

    // when select seller
    if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      let seller = nextProps.Seller;
      if (nextProps.Seller) {
        seller = nextProps.Seller.value;
      }
      let customer = nextProps.Customer;
      if (nextProps.Customer) {
        customer = nextProps.Customer.value;
      }
      let group = this.state.currentGroup;
      let department = this.state.currentDep;
      let category = this.state.currentCategory;
      if(group === -1) {
        group = null;
      }
      if(category === -1) {
        category = null;
      }
      if(category) {
        group = null;
        department = null;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';

      const productNum = this.state.filterProductID;
      if(isCCW && this.state.checkable) {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department);
      } else {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
      }
    }

    // when delete seller
    if (this.props.Seller && nextProps.Seller == null) {
      const seller = nextProps.Seller;
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      const productNum = this.state.filterProductID;
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      let group = this.state.currentGroup;
      let department = this.state.currentDep;
      let category = this.state.currentCategory;
      if(group === -1) {
        group = null;
      }
      if(category === -1) {
        category = null;
      }
      if(category) {
        group = null;
        department = null;
      }
      let customer = nextProps.Customer;
      if (nextProps.Customer) {
        customer = nextProps.Customer.value;
      }
      if(isCCW && this.state.checkable) {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department);
      } else {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
      }
    }
    
    // when select customer
    if (nextProps.Customer && nextProps.Customer !== this.props.Customer) {
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      let seller = nextProps.Seller;
      if (nextProps.Seller) {
        seller = nextProps.Seller.value;
      }
      let customer = nextProps.Customer;
      if (nextProps.Customer) {
        customer = nextProps.Customer.value;
      }
      let group = this.state.currentGroup;
      let department = this.state.currentDep;
      let category = this.state.currentCategory;
      if(group === -1) {
        group = null;
      }
      if(category === -1) {
        category = null;
      }
      if(category) {
        group = null;
        department = null;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';

      const productNum = this.state.filterProductID;
      if(isCCW && this.state.checkable) {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum,  this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department);
      } else {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
      }
    }

    // when delete customer
    if (this.props.Customer && nextProps.Customer == null) {
      let store = this.props.Store;
      if (store) {
        store = store.value || store;
      }
      let seller = nextProps.Seller;
      if (nextProps.Seller) {
        seller = nextProps.Seller.value;
      }
      const customer = nextProps.Customer;
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      const productNum = this.state.filterProductID;
      let department = this.state.currentDep;
      let group = this.state.currentGroup;
      let category = this.state.currentCategory;
      if(group === -1) {
        group = null;
      }
      if(category === -1) {
        category = null;
      }
      if(category) {
        group = null;
        department = null;
      }
      if(isCCW && this.state.checkable) {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department);
      } else {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
      }
    }

    if (nextProps.userFromDate && nextProps.userFromDate !== this.state.userFromDate || nextProps.userFromDate && nextProps.userFromDate !== this.state.userFromDate) {
      let { User } = this.props;
      let Days = this.state.userDays;
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      if (nextProps.userFromDate) {
        fromDate = this.formatDate(nextProps.userFromDate);
      }
      if (nextProps.userToDate) {
        toDate = this.formatDate(nextProps.userToDate);
      }
      if (User) {
        let id = User.value;
        if (Days === '-1' || Days === -1) {
          this.setState((prevState) => ({
            ...prevState,
            userDays: Days,
            columns: [],
          }), () => {
            this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days);
          });
        } else {
          this.setState(prevState => ({
            userDays: Days,
            userFromDate: undefined,
            userToDate: undefined,
            columns: [],
          }), () => {
            this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days);
          })
        }
      }
    }

    if (nextProps.users && nextProps.users !== this.props.users) {
      const sortedUsers = this.sortUsers(nextProps.users);
      this.setState({ users: { rows: sortedUsers } });
    }

    if (nextProps.userPerformanceData && nextProps.userPerformanceData !== this.props.userPerformanceData) {
      const userTableData = [];
      const monthData = [];
      for (const key in nextProps.userPerformanceData) {
        if (key === 'rows') {
          nextProps.userPerformanceData[key].map((sale) => {
            userTableData.push(sale);
          })
        }
        if (key === 'months') {
          nextProps.userPerformanceData[key].map((month) => {
            const profitMonth = month + ' Profit';
            const marginMonth = month + ' Margin';
            if (!monthData.includes(month)) {
              monthData.push(month);
            }
            if (!monthData.includes(profitMonth)) {
              monthData.push(profitMonth);
              monthData.push(marginMonth);
            }
          });
        }
      }
      this.setState(prevState => ({
        users: {
          ...prevState,
          rows: userTableData,
          months: monthData,
        },
        columns: [],
      }), () => {
        this.mergeMonthAndSaleData();
      });
    }
    if (this.props.User !== nextProps.User) {
      this.setState((prevState) => ({
        columns: [],
        users: {
          ...prevState,
          rows: [],
          months: [],
        },
      }))
    }

    if (nextProps.spPDF && nextProps.spPDF !== this.props.spPDF) {
      this.setState({ spPdfFrameLoaded: false });
    }

    if(isCCW && nextProps.groupCategories &&  nextProps.groupCategories.length > 0) {
      let isCheckGroup = this.state.checkedKeys.includes(nextProps.groupCategories[0].ProductGroup_id_id);
      if(isCheckGroup) {
        let childKeys = [...this.state.checkedChildKeys];
        let childIds = nextProps.groupCategories.map(cate => cate.ProductCategory_id);
        childKeys.push(...childIds);
        let set = new Set(childKeys);
        let cpCheckData = {...this.state.checkedData}
        cpCheckData[nextProps.groupCategories[0].ProductGroup_id_id] = [...childIds];
        this.setState({
          checkedChildKeys: Array.from(set),
          checkedData: cpCheckData,
        })
      }
    } 
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.spPdfFrameLoaded !== this.state.spPdfFrameLoaded &&
      this.state.spPdfFrameLoaded === false
    ) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    let productDepartment_id = this.state.currentDep;
    const productGroup_id = this.state.currentGroup;
    const productCategory_id = this.state.currentCategory;
    const groups = document.getElementsByName('group');
    let i = 0;
    for (; i < groups.length; i++) {
      if (groups[i].id !== `g${productGroup_id}`) {
        groups[i].style.backgroundColor = null;
      } else {
        groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }

    const categories = document.getElementsByName('category');
    i = 0;
    if (categories) {
      for (; i < categories.length; i++) {
        if (categories[i].id !== `c${productCategory_id}`) {
          categories[i].style.backgroundColor = null;
        } else {
          categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }

    const deps = document.getElementsByName('dep');
    i = 0;
    for (; i < deps.length; i++) {
      if (deps[i].id !== `d${productDepartment_id}`) {
        deps[i].style.backgroundColor = null;
      } else {
        deps[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }


    if (prevProps.Store !== this.props.Store) {
      this.fetchList();
    }
  }

  fetchList = () => {
    let seller = this.props.Seller;
    if (seller) {
      seller = seller.value || seller;
    }
    let customer = this.props.Customer;
    if (customer) {
      customer = customer.value || customer;
    }
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    if(group === -1) {
      group = null;
    }
    if(category === -1) {
      category = null;
    }
    if(category) {
      group = null;
      department = null;
    }
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';

    const productNum = this.state.filterProductID;
    this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days || 1, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
  }

  formatDate(date) {
    let formattedDate = `${date.getFullYear()}-`;
    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  handleCustomerToDate = (e) => {
    if (e < this.state.users.FromDate) {
      return;
    }
    this.setState(prevState => ({
      users: {
        ...prevState.users,
        ToDate: e,
      },
    }));
  }

  handleCustomerFromDate = (e) => {
    if (e > this.state.users.ToDate) {
      return;
    }
    this.setState(prevState => ({
      users: {
        ...prevState.users,
        FromDate: e,
      },
    }));
  }

  // Used for radiofilter and date picker
  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e });
  }

  setFromDate = (e) => {
    if (e > this.state.ToDate) {
      return;
    }
    this.setState({ FromDate: e });
  }
  
  setToRangeSearch = () => {
    this.setState({ Days: -1 });
  }

  mergeMonthAndSaleData = () => {
    const { months } = this.state.users;
    const rowCopy = this.state.users.rows.slice();
    rowCopy.map((row) => {
      months.map((month) => {
        if (!row.hasOwnProperty(month)) {
          row[month] = 0;
        }
      });
    });
    this.setState(prevState => ({
      users: {
        ...prevState,
        rows: rowCopy,
      },
    }), () => {
      this.handleUserPerformanceShape();
    });
  }

  handleSalesTypeFilterChange = (SalesType) => {
    const productNum = this.state.filterProductID;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if(group === -1) {
      group = null;
    }
    if(category === -1) {
      category = null;
    }
    if(category) {
      group = null;
      department = null;
    }
    this.setState(
      { SalesType },
      () => { 
        if (isCCW && this.state.checkable) {
          this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', this.state.Days || 1, this.state.FromDate, this.state.ToDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department); 
        } else {
          this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', this.state.Days || 1, this.state.FromDate, this.state.ToDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department); 
        }
      },
    );
  }

  // End used for radiofilter and date picker

  handleResize() {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  renderShowDetails = () => (!this.state.filteredByItem ?
    <div style={{ marginTop: '3px' }}>
      <label>
        <input
          style={{ 'font-size': '50px', zoom: '2', marginRight: '2px' }}
          type="checkbox"
          value="showdetails"
          checked={this.state.hide}
          onClick={this.handleShowDetailsChange}
        />
        <Translate value="hide_details" />
      </label>
    </div>
    :
    <div style={{ marginTop: '3px' }}>
      <label>
        <input
          style={{ 'font-size': '50px', zoom: '2', marginRight: '2px' }}
          type="checkbox"
          value="showdetails"
          disabled
          checked={this.state.hide}
          onClick={this.handleShowDetailsChange}
        />
        <Translate value="hide_details" />
      </label>
    </div>
  )

  handleShowDetailsChange = () => {
    this.setState({ hide: !this.state.hide }, () => { this.fetchSalesPerformance(this.state.Days || 1); });
  }

  getPackageTypeOptions() {
    let packageTypeOptions = [];
    if (this.props.packageTypesFetched) {
      this.props.packageTypesFetched.map(packageType => {
        packageTypeOptions.push({value: packageType.Simple, label: packageType.Simple})
      })
    }
    return packageTypeOptions;
  }
  
  refreshList = () => {
    this.fetchSalesPerformance(this.state.Days || 1)
  }

  fetchSalesPerformance(curDays, productSearch) {
    const Days = curDays.toString();
    if (this.state.filteredByItem) {
      if (Days === '-1' || Days === -1) {
        this.setState({ Days }, () => {
          this.handleFetchSalesPerformanceByProduct(this.state.filterProductID);
        });
      } else {
        this.setState({ Days, FromDate: undefined, ToDate: undefined }, () => {
          this.handleFetchSalesPerformanceByProduct(this.state.filterProductID);
        });
      }
      return;
    }
    // let fromDate = '1900-01-01';
    // let toDate = '3000-01-01';
    let fromDate = moment(new Date()).format('YYYY-MM-DD');
    let toDate = moment(new Date()).format('YYYY-MM-DD');
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const SalesType = (this.state.SalesType) ? this.state.SalesType : 'all';
    const productNum = this.props.ProductNum;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    if(group === -1) {
      group = null;
    }
    if(category === -1) {
      category = null;
    }
    if(category) {
      group = null;
      department = null;
    }
    if (Days === '-1' || Days === -1) {
      this.setState({ Days }, () => {
        if (isCCW && this.state.checkable) {
          this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', curDays || this.state.Days, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department);
        } else {
          this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', curDays || this.state.Days, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
        }
      });
    } else {
      this.setState({ Days, FromDate: undefined, ToDate: undefined }, () => {
        if (isCCW && this.state.checkable) {
          this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', curDays || this.state.Days, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store, department);
        } else {
          this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', curDays || this.state.Days, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
        }
      });
    }
  }

  handleLimitChange(el) {
    this.setState({ limit: el.value, limitDisplay: el.label});
    // el.preventDefault();
    this.state.limit = el.value;
    this.state.limitDisplay = el.label;
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const SalesType = this.props.SalesType;

    const productNum = this.props.ProductNum;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    if(group === -1) {
      group = null;
    }
    if(category === -1) {
      category = null;
    }
    if(category) {
      group = null;
      department = null;
    }
    this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, group, category, this.state.hide, seller, customer, store, department);
  }

  printLALASP(curDays) {
    const Days = curDays.toString();

    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }

    if (Days === '-1' || Days === -1) {
      this.setState({ Days }, () => {
        this.props.printSP(curDays || this.state.Days, fromDate, toDate);
      });
    } else {
      this.setState({ Days, FromDate: undefined, ToDate: undefined }, () => {
        this.props.printSP(curDays || this.state.Days, fromDate, toDate);
      });
    }
  }

  fetchUserPerformance = (currentDays) => {
    let allDays;
    this.setState((prevState) => ({
      columns: [],
      userTimeSelection: currentDays,
      users: {
        rows: [],
        months: [],
        list: [],
      },
    }), () => {
      let Days;
      allDays = getDateRangeBetweenDates(currentDays);
      Days = allDays.days.toString();
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      if (this.state.userFromDate) {
        fromDate = this.formatDate(this.state.userFromDate);
      }
      if (this.state.userToDate) {
        toDate = this.formatDate(this.state.userToDate);
      }
      let { User } = this.props;
      if (allDays.lastMonth === false) {
        if (User) {
          let id = User.value;
          if (Days === '-1' || Days === -1) {
            this.setState(prevState => ({
              ...prevState,
              userDays: Days,
              userTimeSelection: currentDays,
            }), () => {
              this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days, false);
            });
          } else {
            this.setState((prevState) => ({
              ...prevState,
              userDays: Days,
              userFromDate: undefined,
              userToDate: undefined,
            }), () => {
              this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days, false);
            })
          }
        } else {
          alert('Please select a user.');
        }
      } else {
        const lastMonth = allDays.lastMonth
        if (User) {
          const id = User.value;
          if (Days.days === '-1' || Days.days === -1) {
            this.setState((prevState) => ({
              ...prevState,
              userDays: Days,
              userTimeSelection: currentDays,
            }), () => {
              this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days, lastMonth);
            });
          } else {
            this.setState((prevState) => ({
              ...prevState,
              userDays: Days,
              userFromDate: undefined,
              userToDate: undefined,
            }), () => {
              this.props.fetchUserPerformanceByFilter(fromDate, toDate, id, false, Days, lastMonth);
            });
          }
        } else {
          alert('Please select a user.');
        }
      }
    });
  }

  handleFetchSalesPerformanceByProduct = (ProductNum) => {
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const SalesType = this.state.SalesType;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    if(group === -1) {
      group = null;
    }
    if(category === -1) {
      category = null;
    }
    if(category) {
      group = null;
      department = null;
    }
    this.setState({ filteredByItem: true, filterProductID: ProductNum, currentGroup: -1 });
    this.props.fetchSalesPerformanceByFilter(this.state.limit, SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', ProductNum, group, category, this.state.hide, seller, customer, store, department);
  }

  handleClickCategory(id, checkFlag) {
    this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const productNum = null;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    (!isCCW || isCCW && !this.state.checkable) && this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, id, this.state.hide, seller, customer, store);
    isCCW && this.state.checkable && checkFlag === 'true' && this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store);
    this.setState({ currentCategory: id });
  }

  renderCategories(group_id) {
    if (!this.props.groupCategories) return;
    const groupCategories = this.props.groupCategories;
    let description;
    if (localStorage.getItem('lang') == 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') == 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup === group_id && this.state.groupExpanded) {
      return groupCategories.map(category => (
        <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={`c${category.ProductCategory_id}`} onClick={this.handleClickCategory.bind(this, category.ProductCategory_id)}>
          <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{` ${category[description]}`}
        </li>
      ));
    }
  }
  debouncedMultiClick = debounce((category) => {
    this.handleClickCategory(category.ProductCategory_id, 'true')
  }, 500);
  renderMultiCategories(group_id){
    if (!this.props.groupCategories) return;
    const groupCategories = this.props.groupCategories;
    let description;
    if (localStorage.getItem('lang') == 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') == 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup === group_id && this.state.groupExpanded) {
      let { checkedKeys, checkedChildKeys } = this.state
      let checkedChildKeysData = checkedChildKeys
      return groupCategories.map(category => (
        <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={`c${category.ProductCategory_id}`} onClick={this.handleClickCategory.bind(this, category.ProductCategory_id)}>
          {isCCW && this.state.checkable && <input
            type="checkbox"
            name="salesPerformanceMulti"
            checked={checkedChildKeys.includes(category.ProductCategory_id)}
            onClick={(e) => {
              e.stopPropagation()
              if (e.target.checked) {
                checkedChildKeysData.push(category.ProductCategory_id)
              }else {
                let cpGroup = checkedKeys.filter(groupId => groupId != category.ProductGroup_id_id);
                checkedChildKeysData = checkedChildKeysData.filter(checkedItem => checkedItem !== category.ProductCategory_id)
                let cpCheckData = {...this.state.checkedData};
                this.setState({checkedKeys: cpGroup, checkData: cpCheckData});
              }
              this.setState({ checkedChildKeys: checkedChildKeysData }, () => {
                this.debouncedMultiClick(category)
              })
            }}
          />}
          <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{` ${category[description]}`}
        </li>
      ));
    }
  }

  handleClickGroup(group, id) {
    this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    const groupExpanded = this.state.groupExpanded;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const productNum = null;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    if (group && this.state.currentGroup === group.ProductGroup_id) {
      this.setState({ groupExpanded: !groupExpanded });
      if (!groupExpanded) {
        this.setState({ currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
        (!isCCW || isCCW && !this.state.checkable) && this.props.fetchSalesPerformanceByFilter(this.state.limit, this.props.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.currentGroup, null, this.state.hide, seller, customer, store);
        isCCW && this.state.checkable && id === 'true' && this.props.fetchSalesPerformanceByFilter(this.state.limit, this.props.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store);      
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
      if(isCCW && this.state.checkable && id === 'true' && groupExpanded) {
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.props.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store);
      }
    } else if (group) {
      this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
      (!isCCW || isCCW && !this.state.checkable) && this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, group.ProductGroup_id, null, this.state.hide, seller, customer, store);
      isCCW && this.state.checkable && id === 'true' && this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.checkedKeys.join(','), this.state.checkedChildKeys.join(','), this.state.hide, seller, customer, store);
      this.props.fetchGroupCategories(group.ProductGroup_id);
    } else {
      this.setState({ currentGroup: -1, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
      this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, null, this.state.hide, seller, customer, store);
    }
  }

  handleClickDep(dep, id) {
    this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    let depExpanded = this.state.depExpanded;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    let store = this.props.Store;
    if (store) {
      store = store.value || store;
    }
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const productNum = null;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    if (dep && this.state.currentDep === dep.ProductDepartment_id) {
      this.setState({ depExpanded: !depExpanded });
      if (!depExpanded) {
        this.setState({ currentGroup: null, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
        this.props.fetchSalesPerformanceByFilter(this.state.limit, this.props.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, this.state.currentGroup, null, this.state.hide, seller, customer, store, dep.ProductDepartment_id);
        // this.props.fetchGroupCategories(group.ProductGroup_id);
        this.props.fetchDepCategories(dep.ProductDepartment_id);
      }
    } else if (dep) {
      this.setState({ currentDep: dep.ProductDepartment_id, depExpanded: true, currentGroup: null, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
      this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, null, this.state.hide, seller, customer, store, dep.ProductDepartment_id);
      this.props.fetchDepCategories(dep.ProductDepartment_id);
    } else {
      this.setState({ currentDep: -1, currentGroup: null, currentCategory: -1, filteredByItem: false, filterProductID: null, suggestValue: '' });
      this.props.fetchSalesPerformanceByFilter(this.state.limit, this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, null, this.state.hide, seller, customer, store, null);
    }
  }


  handleUserPerformanceShape = () => {
    const { rows } = this.state.users;
    const copiedRow = rows.slice();
    const dates = [];
    const newObj = {};
    Object.keys(copiedRow[0]).map((item) => {
      if (item.includes('-')) {
        dates.push(item);
      } else {
        newObj[item] = undefined;
      }
    });
    const sortedArray = this.handleDateShape(dates);
    sortedArray.map((year) => {
      if (!Object.keys(newObj).includes(year)) {
        newObj[year] = 0;
      }
    });
    this.finishInjectingObjectKeys(newObj);
  }

  handleDateShape = (dates) => {
    const sorted = dates.sort((a, b) => {
      const dateA = a.split('-').join();
      const dateB = b.split('-').join();
      return dateA < dateB ? -1 : (dateA > dateB ? 1 : 0);
    })
    return sorted;
  }

  finishInjectingObjectKeys = (obj) => {
    const newRows = [];
    const copiedRows = this.state.users.rows.slice();
    copiedRows.map((row) => {
      const clonedObjectZero = _.cloneDeep(obj);
      for (const key in row) {
          clonedObjectZero[key] = row[key];
      }
      newRows.push(clonedObjectZero);
    });
    this.setState(prevState => ({
      users: {
        ...prevState,
        rows: newRows,
      },
    }), () => {
      this.generateColumns();
    });
  }

  generateColumns = () => {
    const columns = this.state.columns.slice();
    const copiedRows = this.state.users.rows.slice();
    const storage = [];
    copiedRows.map((row) => {
      for (const property in row) {
        const columnObject = {
          key: Math.random(),
          name: undefined,
          resizable: true,
          width: 120,
          sortable: true,
          filterable: true,
        };
        if (!columnObject.name) {
          if (!storage.includes(property)) {
            if (property === 'Customer Name') {
              columnObject.width = 200;
            }
            if (property.slice(8, property.length) === 'Margin') {
              columnObject.width = 135;
            }
            columnObject.key = property;
            columnObject.name = property;
            storage.push(property);
          }
          if (typeof columnObject.key !== 'number') {
            columns.push(columnObject)
          }
        }
      }
    });
    this.setState({
      columns: columns
    });
  }

  // sellers, users
  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }
  renderUsers() {
    if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.

    const Users = this.getUsers();
    return (
      <Field name="Seller" component={Selection} options={Users} />
    );
  }

  spIFrameIsLoaded = () => {
    if (!this.state.spPdfFrameLoaded) {
      const pdfFrame = window.frames.spPDF;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ spPdfFrameLoaded: true });
    }
  };

  renderSPIFrame() { //renderBolByFbaIFrame
    if (this.props.spPDF) {
      const file = window.URL.createObjectURL(this.props.spPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.spIFrameIsLoaded}
          id="spPDF"
          name="spPDF"
          src={file}
        />
      );
    }
  }
  
  // customers
  getCustomers() {
    const Customers = [];
    if(isGGI) {
      this.props.customers.map((customer) => {
        Customers.push({ value: customer.Customer_id, label: `${customer.CustomerNum} ${customer.Name} ${customer.CustomerID}`});
      });
    } else {
      this.props.customers.map((customer) => {
        Customers.push({ value: customer.Customer_id, label: customer.Name});
      });
    }
    return Customers;
  }
  renderCustomers() {
    if (this.props.customersIsLoading) return <Spinner />; // If group is loading, show a spinner.
    const Customers = this.getCustomers();
    if(isGGI) {
      return (
        <Field name="Customer" 
        matchPos="any"
        component={SelectionWithProps} options={Customers} 
        placeholder={'Cust No or Cust Name or Cust Id'}
        onInputKeyDown={(event) => {
          if (event.keyCode === 13) {
            const myField = document.getElementById('sales-auto-suggest');
            if (myField) {
              myField.select();
            }
          }
        }}
        />
      );
    }
    return (
      <Field name="Customer" component={Selection} options={Customers} />
    );
  }

  getStoreOptions = () => {
    const storeOptions = [];
    const arr = Object.entries(this.props.stores)
    arr.map((value, idx) => {
      storeOptions.push({ value: JSON.stringify(value[1]), label: value[0] });
    });
    return storeOptions;
  }
  renderStores = () => {
    if (this.props.storeIsLoading) return <Spinner />; // If group is loading, show a spinner.
    const storeOptions = this.getStoreOptions();
    return (
      <Col xs={3}>
        <label className="col-xs-6"><Translate value="store" /></label>
        <Col xs={6}>
          <Field name="Store" component={Selection} options={storeOptions} />
        </Col>
      </Col>
    );
  }
  debouncedClick = debounce((group) => {
      this.handleClickGroup(group, 'true')
  }, 500);
  renderGroups() {
    if (!this.props.groups) return;
    const groups = this.props.groups;
    let { checkedKeys } = this.state
    let checkedKeysData = checkedKeys
    return groups.map((group) => {
      let GroupNum = parseInt(group.GroupNum);
      if (GroupNum < 10) GroupNum = `0${GroupNum}`;
      let description = 'Misc';
      if (localStorage.getItem('lang') === 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') === 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={`g${group.ProductGroup_id}`} onClick={this.handleClickGroup.bind(this, group, `g${group.ProductGroup_id}`)}>
            {isCCW && this.state.checkable && <input
              type="checkbox"
              name="salesPerformance"
              checked={checkedKeys.includes(group.ProductGroup_id)}
              onClick={
                (e) => {
                  e.stopPropagation()
                  if (e.target.checked) {
                    checkedKeysData.push(group.ProductGroup_id)
                  }else {
                    let cpCheckData = {...this.state.checkedData};
                    let removeIds = cpCheckData[group.ProductGroup_id];
                    let cpCheckedChildIds = [];
                    this.state.checkedChildKeys.map(childKey => {
                      if(removeIds.findIndex(removeId => removeId == childKey) == -1) {
                        cpCheckedChildIds.push(childKey);
                      }
                    })
                    delete cpCheckData[group.ProductGroup_id];
                    checkedKeysData = checkedKeysData.filter(checkedItem => checkedItem !== group.ProductGroup_id)
                    this.setState({
                      checkData: cpCheckData,
                      checkedChildKeys: cpCheckedChildIds,
                    })
                  }
                  this.setState({ checkedKeys: checkedKeysData }, () => {     
                    this.debouncedClick(group)
                  })
                }
              }
            />}
            <label style={{ fontWeight: 'bold' }}>{GroupNum}</label> {' '}<Translate value={group[description]} />
          </div>
          {isCCW ? this.renderMultiCategories(group.ProductGroup_id) : this.renderCategories(group.ProductGroup_id)}
        </Panel>
      );
    });
  }

  renderDeps() {
    if (!this.props.deps) return;
    const deps = this.props.deps;
    return deps.map((dep) => {
      // let GroupNum = parseInt(group.GroupNum);
      // if (GroupNum < 10) GroupNum = `0${GroupNum}`;
      let description = 'Misc';
      if (localStorage.getItem('lang') === 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') === 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div style={{ color: 'purple', marginLeft: '-5px', fontSize: '13px', fontFamily: 'Arial Black', cursor: 'pointer' }} name="dep" id={`d${dep.ProductDepartment_id}`} onClick={this.handleClickDep.bind(this, dep, `d${dep.ProductDepartment_id}`)}>
            <label style={{ fontWeight: 'bold' }}></label> {' '}<Translate value={dep[description]} />
          </div>
          {this.renderGroupsGfd(dep.ProductDepartment_id)}
          {/* {this.renderCategories(group.ProductGroup_id)} */}
        </Panel>
      );
    });
  }

  renderGroupsGfd(dep_id) {
    if (!this.props.groups) return;
    const groups = this.props.groups;
    let description = 'Misc';
    if (localStorage.getItem('lang') === 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') === 'en') {
      description = 'Name';
    }

    if (this.state.currentDep === dep_id && this.state.depExpanded) {
      return groups.map(group => {
        return (
          <div>
            <li className="clickListLi2" style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={'g' + group.ProductGroup_id} onClick={this.handleClickGroup.bind(this, group, 'g' + group.ProductGroup_id)}>
              <label style={{ fontWeight: 'bold' }}></label> {' '}<Translate value={group[description]} />
            </li>
            {this.renderCategories(group.ProductGroup_id)}
          </div>
        );
      })
    }
    return;
    // return groups.map((group) => {
    //   return (
    //     <Panel className="panelStyle" >
    //       <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={`g${group.ProductGroup_id}`} onClick={this.handleClickGroup.bind(this, group, `g${group.ProductGroup_id}`)}>
    //         <label style={{ fontWeight: 'bold' }}></label> {' '}<Translate value={group[description]} />
    //       </div>
    //       {this.renderCategories(group.ProductGroup_id)}
    //     </Panel>
    //   );
    // });
  }

  renderTable() {
    if (this.props.salesPerformanceIsLoading && !this.props.salesPerformanceError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.salesPerformanceError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.salesPerformanceError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.byProduct);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const byProduct = Object.assign({}, this.state.byProduct, { sortColumn, sortDirection });
      this.setState({ byProduct });
    };

    const totalFormatter = React.createClass({
      render() {
        return (isLAP || this.props.dependentValues.Product_id__ProductType === 'Non-Fixed') ?
          <span>{this.props.dependentValues.TotalNetWeight}</span> :
          <span />;
      },
    });

    // filter helper functions
    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.byProduct.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({
        byProduct: {
          filters: newFilters,
          rows: this.state.byProduct.rows,
        },
      });
    };

    const onClearFilters = () => {
      this.setState({
        byProduct: {
          filters: {},
          rows: this.state.byProduct.rows,
        },
      });
    };

    // Column difinition

    const columns = [
      ...(isOLG || isSH) ? []:[{
        key: 'Product_id__ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }],
      {
        key: 'Product_id__RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      },
      ...isAFM && [{
        key: 'Product_id__Brand',
        name: <Translate value="brand" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      {
        key: 'Product_id__Name',
        name: <Translate value="prod_name" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      ...!isSH && [{
        key: 'Product_id__Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }],
      {
        key: (isGGI || isOLG) ? 'final_sold_qty' : 'Quantity',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
      },
      ...!isSH && [{
        key: 'TotalNetWeight',
        name: <Translate value="total_wt" />,
        resizable: true,
        sortable: true,
        width: 70,
        formatter: totalFormatter,
        getRowMetaData: row => row,
        filterable: true,
      }],
      ...isGGI ? [{
        key: 'SmallUnitPrice',
        name: <Translate value="small_unit" />,
        resizable: true,
        sortable: true,
        width: 80,
        formatter: CashFormatter,
        filterable: true,
      }]:[],
      ...!isSH && [{
        key: 'UnitPrice',
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 60,
        formatter: CashFormatter,
        filterable: true,
      }, {
        key: (isGGI || isOLG) ? 'final_sold_price' :'TotalPrice',
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 60,
        formatter: CashFormatter,
        filterable: true,
      }, 
      ...(isLAP && (this.state.SalesType == 'salesorder' || this.state.SalesType == 'all')) ? [
        {
          key: 'RtnQuantity',
          name: <Translate value="rtn_qty" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RtnUnitPrice',
          name: <Translate value="return_final_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RtnWeight',
          name: <Translate value="rtn_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RtnPriceTotal',
          name: <Translate value="return_total" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
      ]:[],
      ...((isHO || isJRC || isLAP) && this.state.hide) ? [] : [{
        key: 'CustomerNum',
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }]],
      ...((isHO || isJRC || isLAP) && this.state.hide) ? [] : [
      {
        key: 'CustomerName',
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      {
        key: 'DeliverDate',
        name: <Translate value="delivered" />,
        resizable: true,
        sortable: true,
        width: 90,
        formatter: DateFormatter,
        filterable: (isHO || isJRC || isLAP) ? false : true,
      },
      {
        key: 'OrderNum',
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'Sales',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
      },
      {
        key: 'SalesInvoice_id__Notation',
        name: <Translate value="notation" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
    ];

    if (this.state.SalesType && this.state.SalesType === 'presale') {
      const indexSalesInvoice = _.findIndex(columns, { key: 'OrderNum' });
      const salesOrderNumColumn = {
        key: 'OrderNum',
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      columns.splice(indexSalesInvoice, 1, salesOrderNumColumn);
    }

    if (isABBLE) {
      const deliverDateIndex = _.findIndex(columns, { key: 'DeliverDate' });
      const storeNameColumn = {
        key: 'StoreName',
        name: <Translate value="store_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      columns.splice(deliverDateIndex, 0, storeNameColumn);
    }

    // React Table Purchase Order Full Table
    return (
      <Row>
        <Col xs={12}>
          <div className="react-table-purchasing-performance" id="SalesPerformance-dataGrid1">
            <ReactDataGrid
              toolbar={<Toolbar enableFilter={true} />}
              enableCellSelect
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={430}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.handleFetchSalesPerformanceByProduct}
            pkgTp={this.state.pkgTp}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em className="fa fa-times pull-right" onClick={() => { this.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, () => { this.fetchSalesPerformance(this.state.days); }); }} />
      </div>
    );
  }

  sortUsers = (newUsers) => {
    if (newUsers.length) {
      const users = newUsers.sort((a, b) => {
        if (a.username.toUpperCase() < b.username.toUpperCase()) {
          return -1;
        } else if (a.username.toUpperCase() > b.username.toUpperCase()) {
          return 1;
        }
        return 0;
      });
      return users;
    }
  }

  handleUserSelection = () => {
    const users = [];
    this.props.users.map((user) => {
      users.push({ value: user.BaseUser_id, label: user.username });
    });
    return users;
  }

  userSetToDate = (e) => {
    if (e < this.state.userFromDate) {
      return;
    }
    this.setState({ userToDate: e });
  }

  userSetFromDate = (e) => {
    this.setState({ userFromDate: e });
  }

  userSetToRangeSearch = () => {
    this.setState({ userDays: -1, userTimeSelection: -1 });
  }

  renderUserPerformanceTab() {
    const { User } = this.props;
    const { userFromDate, userToDate, userDays } = this.state;
    const toDate = formatDate(userToDate);
    const fromDate = formatDate(userFromDate);
    const dates = toFromDates(userDays, fromDate, toDate);
    const users = this.handleUserSelection();
    let store = '';
    if (this.props.Store) {
      store = this.props.Store.value || this.props.Store;
      store = JSON.parse(store).join(',');
      store = `&store=${store}`;
    }
    let id;
    if (User) {
      id = `&userId=${User.value}`;
    } else {
      id = '';
    }
    const userPerformanceTitle = (<Translate value="user_performance" />);
    const excelUrl = `${ROOT_URL}v1/sale/userperformance/?startDate=${dates.fromDate}&endDate=${dates.toDate}${id}&mode=export&Bearer=${localStorage.getItem('token')}${store}`;

    if (isEcity || isDev || isOCM) {
      const Buttons = [
        { days: '30', title: 'Last Month' },
        { days: '60', title: '2 Months' },
        { days: '90', title: '3 Months' },
      ];
      return (
        <Tab eventKey="UserPerformance" title={userPerformanceTitle} >
          <div className="by-quantity-tab">
            <Panel id="date-range-picker" className="form-horizontal">
              <Row>
                <Col xs={2}>
                  <h3 className="filter-title">
                    <Translate value="select_a_user" /><span className="colon">:</span>
                  </h3>
                </Col>
                <Col xs={8} style={{ width: '150px', paddinBottom: '20px', zIndex: 1000000 }}>
                  <Field name="User" component={Selection} matchPos="any" options={users} />
                </Col>
                <Col xs={2}>
                  <div className="user-performance-toolbar">
                    <Button
                      bsStyle="success"
                      href={excelUrl}
                      disabled={!checkPermission('print_sales_performance')}
                    >
                      <em className="fa fa-download" /><Translate value="export" />
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={2}>
                  <h3 className="filter-title"><Translate value="date_range" /><span className="colon">:</span></h3>
                </Col>
                <Col xs={10}>
                  {
                    customizableDateFilterRadios({
                      handleOnClick: this.fetchUserPerformance,
                      userSetFromDate: this.userSetFromDate,
                      userSetToRangeSearch: this.userSetToRangeSearch,
                      userSetToDate: this.userSetToDate,
                      userFromDate: this.state.userFromDate,
                      userToDate: this.state.userToDate,
                      userDays: this.state.userDays,
                      Mode: this.state.userMode,
                      userTimeSelection: this.state.userTimeSelection,
                    })
                  }
                </Col>
              </Row>
              <Row>
                { this.renderCustomersTable() }
              </Row>
            </Panel>
          </div>
        </Tab>
      );
    }
    return (<div />);
  }

  handleTabSelect = (key) => {
    this.setState({
      tabsKey: key,
    });
  }

  renderCustomersTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.users);
    const getSize = () => {
      return getRows().length;
    };

    const rowGetter = (rowIndex) => {
      const rows = getRows();
      return rows[rowIndex];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.users, {
        sortColumn,
        sortDirection,
      });
      this.setState({ state });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.byProduct.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({
        users: {
          filters: newFilters,
          rows: this.state.users.rows,
        },
      });
    };

    const onClearFilters = () => {
      this.setState({
        users: {
          filters: {},
          rows: [],
        },
      });
    };

    return (
      <Row style={{ paddingTop: '20px' }}>
        {
          this.state.columns.length > 0 ? (
            <Col md={12}>
              <div id="UserManagement-dataGrid1">
                <ReactDataGrid
                  rowKey="user_id"
                  enableCellSelect={true}
                  onGridSort={handleGridSort}
                  toolbar={<Toolbar enableFilter={true} />}
                  columns={this.state.columns}
                  rowHeight={25}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  minHeight={this.state.tableHeight}
                  onRowUpdated={this.handleRowUpdated}
                  onAddFilter={handleFilterChange}
                />
              </div>
            </Col>
          ) : (<div />)
        }
      </Row>
    );
  }
  
  generateOrderTypeRadioOptions = () => {
    const options = [
      {
        option: 'all',
        id: 'all-radio-filter',
        name: 'statusFilterRadios',
        labelName: 'all',
      },
      {
        option: 'posorder',
        id: 'open-radio-filter',
        name: 'statusFilterRadios',
        labelName: 'pos',
      },
      {
        option: 'salesorder',
        id: 'salesOrder-radio-filter',
        name: 'statusFilterRadios',
        labelName: isAFM ? 'invoiced' : 'sales_order',
      },
      {
        option: 'presale',
        id: 'presale-radio-filter',
        name: 'statusFilterRadios',
        labelName: isAFM ? 'order' : 'presale',
      },
    ]
    
    if (isGFD) {
      const externalSo = {
        option: 'externalso',
        id: 'externalso-radio-filter',
        name: 'statusFilterRadios',
        labelName: 'external_so',
      }
      options.splice(3, 0, externalSo);
    }
    return options;
  }

  render() {
    const salesType = this.state.SalesType;
    const days = this.state.Days;
    let fromDate = '1900-01-01';
    let toDate = '3000-01-01';
    if (this.state.FromDate) {
      fromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate) {
      toDate = this.formatDate(this.state.ToDate);
    }
    const dates = toFromDates(days, fromDate, toDate);
    if (salesType === 'salesorder') {
      fromDate = `SalesInvoice_id__DispatchDate__gte=${dates.fromDate}`;
      toDate = `SalesInvoice_id__DispatchDate__lte=${dates.toDate}`;
    } else if (salesType === 'posorder') {
      fromDate = `Order_id__Date__gte=${dates.fromDate}`;
      toDate = `Order_id__Date__lte=${dates.toDate}`;
    } else if (salesType === 'all') {
      fromDate = `date__gte=${dates.fromDate}`;
      toDate = `date__lte=${dates.toDate}`;
    } else {
      fromDate = `date__gte=${dates.fromDate}`;
      toDate = `date__lte=${dates.toDate}`;
    }
    let productNum = this.state.filterProductID;
    let department = this.state.currentDep;
    let group = this.state.currentGroup;
    let category = this.state.currentCategory;
    let checkedKeys = this.state.checkedKeys;
    let checkedChildKeys = this.state.checkedChildKeys
    if(group === -1) {
      group = null;
    }
    if(category === -1) {
      category = null;
    }
    if(category) {
      group = null;
      department = null;
    }
    let aggregate = this.state.hide;
    let seller = this.props.Seller;
    if (this.props.Seller) { seller = this.props.Seller.value; }
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    if (productNum) {
      productNum = `&Product_id__ProductNum=${productNum}`;
      group = '';
      department = '';
      category = '';
      if (aggregate) {
        aggregate = `&Aggregate=${aggregate}`;
      } else {
        aggregate = '';
      }
      if (seller) {
        seller = `&Sales_User_id=${seller}`;
      } else {
        seller = '';
      }
      if (customer) {
        customer = `&SalesInvoice_id__Deliver_Customer_id=${customer}`;
      } else {
        customer = '';
      }
    } else {
      productNum = '';
      if (department) {
        department = `&Product_id__ProductDepartment_id=${department}`;
      } else {
        department = '';
      }
      if(isCCW && this.state.checkable) {
        group = `&Product_id__ProductGroup_id=${checkedKeys.join(',')}`;
        category = `&Product_id__ProductCategory1_id=${checkedChildKeys.join(',')}`;
      } else {
        if (group) {
          group = `&Product_id__ProductGroup_id=${group}`;
        } else {
          group = '';
        }
        if (category) {
          category = `&Product_id__ProductCategory1_id=${category}`;
        } else {
          category = '';
        }
      }
      if (aggregate) {
        aggregate = `&Aggregate=${aggregate}`;
      } else {
        aggregate = '';
      }
      if (seller) {
        seller = `&Sales_User_id=${seller}`;
      } else {
        seller = '';
      }
      if (customer) {
        customer = `&SalesInvoice_id__Deliver_Customer_id=${customer}`;
      } else {
        customer = '';
      }
    }

    let store = ''
    if (this.props.Store) {
      store = this.props.Store.value || this.props.Store;
      store = JSON.parse(store).join(',');
      store = `&store=${store}`;
    }

    let companyId = '';
    if (this.props.selectedCompany && this.props.selectedCompany.value) {
      companyId = `&Company_id=${this.props.selectedCompany.value}`;
    }
    let print_url = `${ROOT_URL}v1/sale/performance/print/${
      salesType}/?${fromDate}&${toDate}${productNum}${group}${category
    }${aggregate}${seller}${customer}${companyId}&Bearer=${localStorage.getItem('token')}${store}`;

    let excel_url = `${ROOT_URL}v1/sale/performance/excel/${
      salesType}/?${fromDate}&${toDate}${productNum}${group}${category
    }${aggregate}${seller}${customer}${companyId}&Bearer=${localStorage.getItem('token')}${store}`;

    let lowest_sale_url = `${ROOT_URL}v1/sale/get_report_lowest?${fromDate}&${toDate}&Bearer=${localStorage.getItem('token')}`;

    // AFM report url BelongWarehouse
    const warehouse = localStorage.getItem('warehouseLocation');
    let report_url = '';
    if (warehouse==='All' || warehouse===null) {
      report_url = `${ROOT_URL}v1/sale/performance_categories?${
        fromDate}&${toDate}&Bearer=${localStorage.getItem('token')}`;
    } else {
      report_url = `${ROOT_URL}v1/sale/performance_categories?${
        fromDate}&${toDate}&BelongWarehouse=${warehouse}&Bearer=${localStorage.getItem('token')}`;
    }
    if((isABBLE || isOCM) && this.props.selectedWarehouse && this.props.selectedWarehouse.value && this.props.selectedWarehouse.value != 0) {
      print_url += `&Pickup_Warehouse_id_id=${this.props.selectedWarehouse.value}`;
      excel_url += `&Pickup_Warehouse_id_id=${this.props.selectedWarehouse.value}`;
      lowest_sale_url += `&Pickup_Warehouse_id_id=${this.props.selectedWarehouse.value}`;
    }
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    if(isOLG || isGGI) {
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        print_url += `&time_zone=${zone}&time_diff=${time}`;
      } else {
        print_url += `&time_zone=${(time)}&time_diff=${time}`;
      }
    }
    if (isHO || isJRC || isLAP) {
      let filtersData = this.state.byProduct.filters;
      let sortColumn = this.state.byProduct.sortColumn;
      let sortDirection = this.state.byProduct.sortDirection;
      let filterObj = {};
      if (Object.keys(filtersData).length) {
        for (const key in filtersData) {
          filterObj[key] = filtersData[key].filterTerm
        }
        excel_url += `&filter_obj=${JSON.stringify(filterObj)}`
        print_url += `&filter_obj=${JSON.stringify(filterObj)}`
      }
      if (sortColumn) {
        if (sortDirection === 'ASC') {
          excel_url +=  `&sort_field=${sortColumn}`
          print_url +=  `&sort_field=${sortColumn}`
        } else {
          excel_url +=  `&sort_field=-${sortColumn}`
          print_url += `&sort_field=-${sortColumn}`
        }
      }
      excel_url += `&time_diff=${(time)}`;
      print_url += `&time_diff=${(time)}`;
    }

    const limitSelection = [
      {
        label: 'ALL',
        value: 'ALL',
      },
      {
        label: 'MSO',
        value: 'MSO',
      },
      {
        label: 'SO',
        value: 'SO',
      },
    ];

    // const handleLimitChange = (el) => {
    //   // this.setState({ limit: el.value, limitDisplay: el.label});
    //   el.preventDefault();
    //   this.state.limit = el.value;
    //   this.state.limitDisplay = el.label;

    //   this.props.setDefaultOfForm('ProductNum', null, 'salesPerformance');
    // let fromDate = '1900-01-01';
    // let toDate = '3000-01-01';
    // if (this.state.FromDate) {
    //   fromDate = this.formatDate(this.state.FromDate);
    // }
    // if (this.state.ToDate) {
    //   toDate = this.formatDate(this.state.ToDate);
    // }
    // const productNum = null;
    // this.props.fetchSalesPerformanceByFilter(this.state.SalesType || 'posorder', this.state.Days, fromDate, toDate, 'show', productNum, null, id, this.state.hide, null);
    // }
    
    const productPerformanceTitle = (<Translate value="sales_performance" />);
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="sales_performance" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid id="sales-performance">
          <Row>
            <Tabs activeKey={this.state.tabsKey} justified onSelect={this.handleTabSelect}>
              <Tab eventKey="ProductPerformance" title={productPerformanceTitle} style={{ height: '750px' }}>
                {/* Category Nav */}
                <Col xs={2}>
                  <Panel id="category-nav" className="panelStyle">
                  { 
                    isCCW && this.state.checkable && <div style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial', cursor: 'pointer', marginBottom: '5px', textAlign: 'right' }} onClick={() => {this.setState({checkable: false, checkedKeys: [], checkedChildKeys: []})}}>
                      <Translate value="prohibit_multi_select" />
                    </div>
                  }
                  { 
                    isCCW && !this.state.checkable && <div style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial', cursor: 'pointer', marginBottom: '5px', textAlign: 'right' }} onClick={() => {this.setState({checkable: true})}}>
                      <Translate value="allows_multi_select" />
                    </div>
                  }
                  {!(isGFD && true) &&
                    <Panel className="panelStyle" >
                      <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="group" id="g-1" onClick={() => {this.setState({checkedKeys: [], checkedChildKeys: []}, () => {this.handleClickGroup(null, '-1')})}}>
                        <Translate value="all" />
                      </div>
                    </Panel>
                  }
                  {(isGFD && true) &&
                    <Panel className="panelStyle" >
                      <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="dep" id="d-1" onClick={this.handleClickDep.bind(this, null, '-1')}>
                        <Translate value="all" />
                      </div>
                    </Panel>
                  }
                    {!(isGFD && true) && this.renderGroups()}
                    {(isGFD && true) && this.renderDeps()}
                  </Panel>
                </Col>

                {/* Date Range Pickers */}
                <Col xs={10}>
                  <Panel id="date-range-picker" className="form-horizontal">
                    <Row>
                      <Col xs={1}>
                        <h3 className="filter-title"><Translate value="filter" /><span className="colon">:</span></h3>
                      </Col>
                      <Col xs={11}>
                        <div id="statusFilterRadios" className="form-horizontal">
                          {/* <Field name='Status' component={ renderStatusRadios }  /> */}
                          {
                            genericRadioFilter({
                              content: this.generateOrderTypeRadioOptions(),
                              value: this.state.SalesType,
                              handleOnClick: type => this.handleSalesTypeFilterChange(type),
                              type: "buttons",
                            })
                          }
                        </div>
                      </Col>
                      <Col xs={11} xsOffset={1}>
                        {
                          dateFilterRadios({
                            handleOnClick: this.fetchSalesPerformance,
                            setFromDate: this.setFromDate,
                            setToRangeSearch: this.setToRangeSearch,
                            setToDate: this.setToDate,
                            FromDate: this.state.FromDate,
                            ToDate: this.state.ToDate,
                            Days: this.state.Days,
                          })
                        }
                      </Col>
                    </Row>
                  </Panel>
                </Col>
                {/* End Date Range Pickers */}

                {/* Sales Performance Table */}
                <Col xs={10}>
                  <Panel className="table-collapse-fix">
                    <Row>
                      <Col xs={(isAFM||isOCM) ? 4 : 2}>
                        <Row style={{ marginLeft: '7px' }}>
                          <ButtonToolbar>
                            <Button
                              bsStyle="primary"
                              href={print_url}
                              disabled={!checkPermission('print_sales_performance')}
                            >
                              <em className="fa fa-print" /><Translate value="print" />
                            </Button>
                            <Button
                              bsStyle="success"
                              href={excel_url}
                              disabled={!checkPermission('print_sales_performance')}
                            >
                              <em className="fa fa-download" /><Translate value="excel" />
                            </Button>
                            {
                              isOCM &&
                              <Button
                                bsStyle="success"
                                href={lowest_sale_url}
                                disabled={!checkPermission('print_sales_performance')}
                              >
                                <em className="fa fa-download" /><Translate value="lowest_sales" />
                              </Button>
                            }
                          </ButtonToolbar>
                        </Row>
                        {
                          isAFM &&
                          <Row style={{marginTop: "5px"}}>
                            <ButtonToolbar>
                              <Button
                                bsStyle="primary"
                                href={report_url}
                                disabled={!checkPermission('print_sales_performance')}
                              >
                                <em className="fa fa-download" /><Translate value="report" />
                              </Button>
                              <Button
                                bsStyle="primary"
                                onClick={() => {
                                  // this.props.printSP(1);
                                  this.printLALASP(this.state.Days);
                                }}
                                disabled={false}
                              >
                                <em className="fa fa-print" /> PDF Report
                              </Button>
                              {/* <Dropdown>
                                <Dropdown.Toggle style={{ height: '25px', width: '80px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                  {this.state.limitDisplay}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="super-colors">
                                  {limitSelection.map(el => {
                                    return (
                                      <MenuItem onClick={() => this.handleLimitChange(el)}>{el.label}</MenuItem>
                                    )
                                  })}
                                </Dropdown.Menu>
                              </Dropdown> */}
                              {this.renderSPIFrame()}
                            </ButtonToolbar>
                          </Row>
                        }
                      </Col>
                      <Col xs={(isAFM||isOCM) ? 8 : 10}>
                        <div id="autosuggest-div">
                          <Row style={{ height: '30px' }}>
                            <Col xs={isSH ? 10 : 12}>
                              <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} barcodeSearch/>
                            </Col>
                            {isSH &&
                              <Col xs={2}>
                                <label><Translate value="package_type_filter" /></label>
                              </Col>
                            }
                          </Row>
                          <Row>
                            <Col xs={isSH ? 10 : 12}>
                              {this.renderAutoSuggest()}
                            </Col>
                            {isSH &&
                              <Col xs={2}>
                                <Select
                                  className='testSelect'
                                  options={this.getPackageTypeOptions()}
                                  onChange={(pkgTp)=>{
                                    this.setState({pkgTp})
                                  }}
                                  matchPos={"center"}
                                  matchProp={'label'}
                                  value={this.state.pkgTp}
                                />
                              </Col>
                            }
                          </Row>
                        </div>
                        {/*
                          <Button bsStyle="primary" onClick={() => { this.fetchSalesPerformance(-1, true); }}>
                          <em className="fa fa-search" />
                        </Button>
                        */}
                      </Col>
                    </Row>
                    <Row style={{ 'padding-bottom': '5px', display: 'flex', flexDirection: 'row', marginLeft: '7px' }}>
                      { (!isAFM || true) && 
                        <div style={{ ...styles.titleLabel }}>
                          <Translate value="seller" />
                        </div>
                      }
                      { (!isAFM || true) && 
                        <div style={{ ...styles.titleField }}>
                          { this.renderUsers() }
                        </div>
                      }
                      <div style={{ ...styles.titleLabel }}>
                        <Translate value="sale_qty" />
                      </div>
                      <div style={{ ...styles.titleField }}>
                        <Field name="SaleQTY" component={DisabledInputField} placeholder={this.state.saleQTY} />
                      </div>
                      <div style={{ ...styles.titleLabel, width: '91px' }}>
                        <Translate value="total_item_sale" />
                      </div>
                      <div style={{ ...styles.titleField }}>
                        <Field name="sum" component={DisabledInputField} placeholder={this.state.sum} />
                      </div>
                      <div style={{ ...styles.titleLabel, width: '69px' }}>
                        <Translate value="avg_sale_dollarsign" />
                      </div>
                      <div style={{ ...styles.titleField }}>
                        <Field name="AVGSalePrice" component={DisabledInputField} placeholder={this.state.avgSalePrice} />
                      </div>
                      <div style={{ ...styles.titleLabel, width: '92px' }}>
                        <Translate value="avg_markup_percentsign" />
                      </div>
                      <div style={{ ...styles.titleField }}>
                        <Field name="AvgMarkupPct" component={DisabledInputField} placeholder={this.state.avgMarkupPct ? this.state.avgMarkupPct.toFixed(2) : 0} />
                      </div>
                      {this.renderShowDetails()}
                    </Row>

                    {/* {isAFM &&
                    <Row style={{ 'padding-bottom': '5px', display: 'flex', flexDirection: 'row', zIndex: '2', position: 'absolute' }}>
                      <div style={{ ...styles.titleLabel }}>
                        <Translate value="seller" />
                      </div>
                      <div style={{ ...styles.titleField }}>
                        { this.renderUsers() }
                      </div>

                      <div style={{ ...styles.titleLabel2 }}>
                        <Translate value="order_type" />
                      </div>
                      <div style={{ ...styles.titleField }}>
                      <Dropdown>
                        <Dropdown.Toggle style={{ height: '25px', width: '80px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                          {this.state.limitDisplay}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="super-colors">
                          {limitSelection.map(el => {
                            return (
                              <MenuItem onClick={() => this.handleLimitChange(el)}>{el.label}</MenuItem>
                            )
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    </Row>
                      } */}
                    {/* <Row style={{ 'padding-bottom': '5px' }}>
                      <Col xs={2}>
                        <Row>
                          <Col xs={4}>
                            <label className="col-xs-6"><Translate value="seller" /></label>
                          </Col>
                          <Col xs={8}>
                            { this.renderUsers() }
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={2}>
                        <Row>
                          <Col xs={4}>
                            <label className="col-xs-4"><Translate value="qty" /></label>
                          </Col>
                          <Col xs={8}>
                            <Field name="SaleQTY" component={DisabledInputField} placeholder={this.state.saleQTY} />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={2}>
                        <Row>
                          <Col xs={4}>
                            <label className="col-xs-6"><Translate value="total_item_sale" /></label>
                          </Col>
                          <Col xs={8}>
                            <Field name="sum" component={DisabledInputField} placeholder={this.state.sum} />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={2} id="avgSale">
                        <Row>
                          <Col xs={5}>
                            <label className="col-xs-5"><Translate value="avg_sale_dollarsign" /></label>
                          </Col>
                          <Col xs={7}>
                          <Field name="AVGSalePrice" component={DisabledInputField} placeholder={this.state.avgSalePrice} />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={2} id="avgMarkupPct">
                        <label className="col-xs-7"><Translate value="avg_markup_percentsign" /></label>
                        <Col xs={5} id="avgmarkup-input">
                          <Field name="AvgMarkupPct" component={DisabledInputField} placeholder={this.state.avgMarkupPct} />
                        </Col>
                      </Col>
                      <Col xs={2}>
                        {this.renderShowDetails()}
                      </Col>
                    </Row> */}
                    {
                        <Row>
                          <Col xs={isGGI ? 4 : 3}>
                            <label className="col-xs-6"><Translate value="customer" /></label>
                            <Col xs={isGGI ? 8 : 6}>
                              { this.renderCustomers() }
                            </Col>
                          </Col>
                          {
                            (isFung || isOCM || isAN || isABBLE || isCPG || isVIP || isDAICHEONG || isSKH) && 
                              this.renderStores()
                          }
                        </Row>
                    }
                    { this.renderTable() }
                  </Panel>
                </Col>
              </Tab>
              { this.renderUserPerformanceTab() }
            </Tabs>
          </Row>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default SalesPerformance;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesPerformance.jsx